module.exports = __webpack_public_path__ + "media/images/dots-f14afdde2b0875dafc1598f59295cf44.png";